import _ from 'lodash'
import BaseNonDatasetReportForm from '../common/base-non-dataset-report-form'
import InitiativeReportTableModel from './initiative-report-table-model'
import InitiativeReportFilterMeta from 'scoreboard/reports/wizard/initiative-report/initiative-filter-meta'
import initiativeFilterExplanationBanner from 'scoreboard/reports/wizard/initiative-report/initiative-filter-explanation-banner.hbs'

const InitiativeReportForm = BaseNonDatasetReportForm.extend({

	recordTypeCode: 'initiatives.initiatives',

	_filterMeta: InitiativeReportFilterMeta,

	_filterTitle: 'report.initiativeReport.title',

	_filterBanner: function () {
		return initiativeFilterExplanationBanner()
	},

	_filterOptions: function() {
		return {
			groupBy: null		//#17480 don't group initiative filters
		}
	},

	_reportTableModel() {
		return InitiativeReportTableModel
	}

})

export default InitiativeReportForm

InitiativeReportForm.__filename__ = 'reports/initiative-report/initiative-report-form.js'
